<template>

    <div class="text-center" v-if="$apollo.queries.readTeamMembers.loading">
        Loading...
    </div>
    <div v-else>
        <div class="grid grid-center center-links-four-cols content-stretch items-stretch">
            <div v-for="(member, index) in readTeamMembers.nodes"
                 :class="['relative flex h-full w-full flex-col content-center items-center grid-item', member.description ? 'group cursor-pointer' : '']"
                 @click="member.description ? setViewedMember($event) : null" :popovertarget="member.description ? 'member-bio' : null" :data-index="index">
                <div class="relative mb-2 overflow-hidden rounded-[225px] mx-[30px]">
                    <img v-if="member.imageDisplayMediumSize" :src="member.imageDisplayMediumSize"
                         class="aspect-square z-[1]"/>
                    <img v-else :src="defaultImage" class="aspect-square z-[1]"/>
                    <div v-if="member.description"
                        class="invisible !absolute before:absolute top-0 left-0 flex h-full before:h-full w-full
                                before:w-full items-center justify-center before:opacity-50 banner-overlay banner-overlay-dark z-[2]
                                group-hover:visible">
                        <button @click="setViewedMember($event)" popovertarget="member-bio" :data-index="index"
                                class="h-full w-full uppercase font-semibold z-[1] text-white text-[16px] py-[16px] px-[30px]">
                            Read bio
                        </button>
                    </div>
                </div>
                <div class="w-full rounded inner-box mt-[-100px] pt-[100px] px-p20 flex-grow">
                    <p class="mb-2 text-center">
                        <span class="font-semibold text-[22px]">{{ member.name }}</span>
                    </p>
                    <p class="text-center">
                        <span
                            class="uppercase py-[4px] h4">{{ member.jobTitle }}</span>
                    </p>
                </div>
            </div>
        </div>

        <div popover id="member-bio" class="!fixed top-0 left-0 h-full bg-transparent w-full banner-overlay banner-overlay-very-dark after:z-[1] "
             popovertarget="member-bio">
            <div class="flex h-full w-full items-center justify-center relative z-[2] p-[20px]">
                <div class="relative w-full p-[20px] rounded lg:p-[50px] lg:w-2/3 inner-box">
                <button class="absolute top-[20px] right-[20px] p-[10px]"
                            popovertarget="member-bio">
                        <span class="block ph ph-x text-[24px]"></span>
                    </button>

                    <div class="flex flex-col items-start md:flex-row lg:items-center">
                        <div class="order-1 md:hidden">
                            <h4 class="mt-0 mb-2">{{ readBioName }}</h4>
                            <span
                                class="py-[4px] h5">{{ readBioJobTitle }}</span>
                        </div>

                        <div
                            class="relative w-full order-2 mt-4 mb-4 text-center overflow-hidden md:basis-[33%] md:order-1 md:mt-0 md:mb-0">
                            <img v-if="bioImage" width="100%" :src="bioImage" class="mx-auto rounded"/>
                            <img v-else width="100%" :src="defaultImage" class="mx-auto rounded"/>
                        </div>

                        <div class="order-3 md:basis-[66%] md:order-2 md:pl-5 lg:pl-[50px]">
                            <h4 class="mt-0 hidden md:mb-2 md:block">{{ readBioName }}</h4>
                            <span
                                class="hidden font-semibold uppercase py-[4px]  md:inline">{{ readBioJobTitle }}</span>
                            <div class="md:mt-3" v-html="readBioContent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import gql from 'graphql-tag';

export default {
    name: "TeamMembers",
    data: {
        readBioName: "",
        readBioJobTitle: "",
        readBioContent: "",
        profileImage: "",
        bioImage: ""
    },
    props: {
        defaultImage: {
            type: String,
            default: ""
        },
        panelId: {
            type: String,
            default: 0
        },
    },
    computed: {
        panelIdInt: function () {
            return parseInt(this.panelId);
        }
    },
    methods: {
        setViewedMember: function (event) {
            var currentMemberIndex = event.target.dataset.index;
            var currentMember = this.readTeamMembers.nodes[currentMemberIndex];

            this.readBioName = currentMember.name;
            this.readBioJobTitle = currentMember.jobTitle;
            this.readBioContent = currentMember.description;
            this.profileImage = currentMember.imageDisplayMediumSize;
            this.bioImage = currentMember.imageTeamMemberBio;
        },
    },
    apollo: {
        readTeamMembers: {
            query: gql`
                query readTeamMember($panelIdInt: ID!) {
                    readTeamMembers (filter: {panel: { id: { eq: $panelIdInt } } }){
                        nodes {
                            id
                            name
                            imageDisplayMediumSize
                            imageTeamMemberBio
                            jobTitle
                            description
                        }
                    }
                }`,
            variables() {
                return {
                    panelIdInt: this.panelIdInt
                }
            },
            fetchPolicy: 'cache-and-network'
        }
    },
    render: h => h(App),
}
</script>
